import { gsap } from 'gsap'

export class FormDisplay {
  constructor() {
    if (document.querySelector('.c-form') === null) return
    const trgList = Array.prototype.slice.call(document.querySelectorAll('.js-form_display_trg'), 0)

    trgList.forEach(function (target) {
      let radioArr = target.querySelectorAll(`input[type='radio']`)
      radioArr.forEach(function (el) {
        el.addEventListener('change', (event) => {
          let $this = event.currentTarget
          if ($this.value === '参加する') {
            gsap.to('.js-form_display_target', 0.5, { display: 'block' })
          } else {
            gsap.to('.js-form_display_target', 0.5, { display: 'none' })
          }
        })
      })
    })
  }
}
